<template>
    <router-link :to="video.link" :title="video.title" class="clean" >
        <div class="uk-card uk-card-default uk-box-shadow-hover-large card-video">

            <div class="uk-card-media-top">
                <div class="ar16x9 uk-background-cover" v-bind:style="{ backgroundImage: `url(${video.featuredImage})` }" :alt="video.title"></div>
            </div>

            <div class="uk-card-body uk-text-left">
                <h5 class="uk-card-title uk-margin-bottom"><b>{{video.title}}</b></h5>

                <b class="text-blue">{{video.category.id >0 ? video.category.title : "&nbsp;"}}</b>
            </div>

        </div>
    </router-link>
</template>

<script>
export default {
    props: ['video', 'setCategory']
}
</script>
